import { render, staticRenderFns } from "./BusinessMemberConfirmEmailAddressView.vue?vue&type=template&id=6d3e4dcf"
import script from "./BusinessMemberConfirmEmailAddressView.vue?vue&type=script&lang=js"
export * from "./BusinessMemberConfirmEmailAddressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports